import { Environments } from "../environmentInfo/Constants";
import {
  ASSOCIATE_INFORMATION_CONSTANTS,
  FILE_ATTACHMENTS_CONSTANTS,
  INCIDENT_INFORMATION_CONSTANTS,
  INCIDENT_TIME_AND_PLACE_CONSTANTS,
  PHYSICIAN_INFORMATION_CONSTANTS,
  REVIEW_PAGE_CONSTANTS,
} from "../forms/constants";

export const FORM_PAGE_ERROR_MESSAGE =
  "Please fix all the errors in the form before proceeding.";

export const STEP_NAMES = [
  ASSOCIATE_INFORMATION_CONSTANTS.FORM_NAME,
  INCIDENT_TIME_AND_PLACE_CONSTANTS.FORM_NAME,
  INCIDENT_INFORMATION_CONSTANTS.FORM_NAME,
  PHYSICIAN_INFORMATION_CONSTANTS.FORM_NAME,
  FILE_ATTACHMENTS_CONSTANTS.FORM_NAME,
  REVIEW_PAGE_CONSTANTS.FORM_NAME,
];
export const MAX_STEPS = STEP_NAMES.length;

export const DUPLICATE_MODAL_TITLE = "Similar Claim Found";
export const DUPLICATE_CHECK_ERROR_MODAL_TITLE = "Duplicate Check Error";
export const CLAIM_RETRIEVAL_ERROR_MODAL_TITLE = "Unable to Load Claim";
export const CLAIM_ALREADY_COMPLETED_MODAL_TITLE = "Claim Already Completed";

// Test user aliases for automated testing (claims submitted by these users are marked as test records)
export const TEST_USER_ALIASES = [
  "svc-mw-788277276912-ui-tests", // Beta environment test user
  "svc-mw-567981344308-ui-tests", // Gamma environment test user
];

export const CHILD_ROUTES = {
  // ADMIN ROUTES
  SITE_CONFIGURATION: "/site-configuration",
  DOCUMENTS_MANAGEMENT: "/documents-management",

  // WORKERS COMPENSATION ROUTES
  WC_CLAIM_INTAKE_FORM: "/claim-intake-form",
  MEDICAL_PANEL_DATA: "/medical-panel-data",
  MY_SUBMITTED_CLAIMS: "/my-submitted-claims",
  CLAIMS_HISTORY: "/claims-history",
  WORKERS_COMPENSATION_DOCUMENTS: "/documents",
  LEGACY_WORKERS_COMPENSATION_DOCUMENTS: "/workers-compensation-documents",

  // CARGO ROUTES
  CARGO_CLAIM_INTAKE_FORM: "/claim-intake-form",
  CARGO_CONTINUE_FORM: "/claim-intake-form/continue",
  CARGO_CLAIMS_HISTORY: "/claims-history",

  // IPL ROUTES
  IPL_CLAIM_INTAKE_FORM: "/claim-intake-form",
  IPL_CLAIMS_HISTORY: "/claims-history",
};

export const INDEX_ROUTES = {
  ADMIN: `/admin`,
  WORKERS_COMPENSATION: `/workers-compensation`,
  CARGO: `/cargo`,
  IPL: `/ipl`,
};

export const ROUTES = {
  // ADMIN ROUTES
  SITE_CONFIGURATION: `${INDEX_ROUTES.ADMIN}${CHILD_ROUTES.SITE_CONFIGURATION}`,
  DOCUMENTS_MANAGEMENT: `${INDEX_ROUTES.ADMIN}${CHILD_ROUTES.DOCUMENTS_MANAGEMENT}`,

  // WORKERS COMPENSATION ROUTES
  WC_CLAIM_INTAKE_FORM: `${INDEX_ROUTES.WORKERS_COMPENSATION}${CHILD_ROUTES.WC_CLAIM_INTAKE_FORM}`,
  MEDICAL_PANEL_DATA: `${INDEX_ROUTES.WORKERS_COMPENSATION}${CHILD_ROUTES.MEDICAL_PANEL_DATA}`,
  MY_SUBMITTED_CLAIMS: `${INDEX_ROUTES.WORKERS_COMPENSATION}${CHILD_ROUTES.MY_SUBMITTED_CLAIMS}`,
  CLAIMS_HISTORY: `${INDEX_ROUTES.WORKERS_COMPENSATION}${CHILD_ROUTES.CLAIMS_HISTORY}`,
  WORKERS_COMPENSATION_DOCUMENTS: `${INDEX_ROUTES.WORKERS_COMPENSATION}${CHILD_ROUTES.WORKERS_COMPENSATION_DOCUMENTS}`,

  // CARGO ROUTES
  CARGO_CLAIM_INTAKE_FORM: `${INDEX_ROUTES.CARGO}${CHILD_ROUTES.CARGO_CLAIM_INTAKE_FORM}`,
  CARGO_CONTINUE_FORM: `${INDEX_ROUTES.CARGO}${CHILD_ROUTES.CARGO_CONTINUE_FORM}`,
  CARGO_CLAIMS_HISTORY: `${INDEX_ROUTES.CARGO}${CHILD_ROUTES.CARGO_CLAIMS_HISTORY}`,

  // IPL ROUTES
  IPL_CLAIM_INTAKE_FORM: `${INDEX_ROUTES.IPL}${CHILD_ROUTES.IPL_CLAIM_INTAKE_FORM}`,
  IPL_CLAIMS_HISTORY: `${INDEX_ROUTES.IPL}${CHILD_ROUTES.IPL_CLAIMS_HISTORY}`,

  // MISCELANEOUS ROUTES
  LANDING_PAGE: `/landing-page`,
};

export enum PAGE_TITLES {
  CLAIM_INTAKE_FORM = "Claim Intake",
  MEDICAL_PANEL_DATA = "Preferred Provider List/Medical Provider Panel",
  SITE_CONFIGURATION = "Nucleus Sites Admin Panel",
  MY_SUBMITTED_CLAIMS = "My Submitted Claims",
  CLAIMS_HISTORY = "Claims History",
  WORKERS_COMPENSATION_DOCUMENTS = "Workers' Compensation Documents",
  DOCUMENTS_MANAGEMENT = "Admin Document Manager",
  CARGO_CLAIM_INTAKE_FORM = "Claim Intake Form",
  IPL_CLAIM_INTAKE_FORM = "IPL Claim Intake Form",
  LANDING_PAGE = "Nucleus",
}

// Use this definition to change where the local environment points to when testing
export const LOCALHOST_SERVICE_ENVIRONMENT = Environments.BETA;
export const WC_USER_GUIDE_URL =
  "https://w.amazon.com/bin/view/Treasury/TreasuryTech/ClaimIntake/ClientDocumentation/GettingStarted/";

export const CARGO_USER_GUIDE_URL =
  "https://w.amazon.com/bin/view/Main/Risk_Management/Cargo/Nucleus_Cargo_User_Guide/";

export const IPL_USER_GUIDE_URL =
  "https://w.amazon.com/bin/view/Main/Risk_Management/Cargo/Nucleus_IPL_User_Guide/";

export const ACCESS_REQUEST_URL =
  "https://t.corp.amazon.com/create/templates/4a7bb0de-3bc7-4133-8616-97de840b2777";

export const AMAZON_CLAIM_REFERENCE_ID_MAX_SIZE = 10;

export const EMPTY_STRING_INDICATOR = "-";
